import onceCB from "../../util/onceCB";
import { needToDeploy } from "./selectors";
import getText from "./texts";
import { UserCanceled } from "../../util/CustomErrors";
function queryDeploy(api) {
    const state = api.store.getState();
    if (!needToDeploy(state)) {
        return Promise.resolve("auto");
    }
    else {
        const t = api.translate;
        return Promise.resolve(api.showDialog("question", t("Pending deployment"), {
            bbcode: t("Mod deployment {{more}} is pending.[br][/br]" +
                "This means that changes made to mods such as updating, " +
                "enabling/disabling, as well as newly set mod rules need to be deployed to take effect.[br][/br]" +
                "You can skip this step, ignoring (but not reverting) newly made changes to mods and mod rules, " +
                "or deploy now to commit the changes.", {
                replace: {
                    more: `[More id='more-deploy' name='${t("Deployment")}']${getText("deployment", t)}[/More]`,
                },
            }),
        }, [{ label: "Cancel" }, { label: "Skip" }, { label: "Deploy" }])).then((result) => {
            switch (result.action) {
                case "Skip":
                    return "skip";
                case "Deploy":
                    return "yes";
                default:
                    return "cancel";
            }
        });
    }
}
function checkDeploy(api) {
    return queryDeploy(api).then((shouldDeploy) => {
        if (shouldDeploy === "yes") {
            return new Promise((resolve, reject) => {
                api.events.emit("deploy-mods", onceCB((err) => {
                    if (err !== null) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                }));
            });
        }
        else if (shouldDeploy === "auto") {
            return new Promise((resolve, reject) => {
                api.events.emit("await-activation", (err) => {
                    if (err !== null) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                });
            });
        }
        else if (shouldDeploy === "cancel") {
            return Promise.reject(new UserCanceled());
        }
        else {
            // skip
            return Promise.resolve();
        }
    });
}
function preStartDeployHook(api, input) {
    return input.options.suggestDeploy === true
        ? checkDeploy(api).then(() => input)
        : Promise.resolve(input);
}
export default preStartDeployHook;
